<template>
    <div id="home-how-its-work">
        <img class="absolute bkg-grey" height="1093px" width="48%" src="@/assets/images/main/Rectangle 501.png" :class="{lg:$vuetify.breakpoint.lg}" v-if="$vuetify.breakpoint.lgAndUp">
        <img class="absolute bkg-grey-tablet" width="100%" height="1162px" src="@/assets/images/main/Rectangle 682.png" v-else>
        <!-- <img class="absolute screen-app" height="409.45px" width="37%" src="@/assets/images/main/themes.png" :class="{lg:$vuetify.breakpoint.lg}" v-if="$vuetify.breakpoint.lgAndUp"> -->
        <img class="absolute field" height="134px" width="49.5%" src="@/assets/images/main/Vector 17.png" v-if="$vuetify.breakpoint.lgAndUp">
        <img class="absolute field-tablet" height="134px" width="100%" src="@/assets/images/main/Vector 51.png" v-else>
        <!-- <div class="absolute text" :class="{lg:$vuetify.breakpoint.lg}" v-if="$vuetify.breakpoint.lgAndUp">
            <div class="ml-8 roboto-bold-24 clr-black-38">Создание раздела</div>
            <div class="mt-7 ml-9 roboto-normal-24 clr-black-38">
            Здесь будет анимация, будут меняться картинки, а внизу будет описание того, что происходит
            </div>
        </div>
        <div class="absolute text-tablet" v-else :class="{sm:$vuetify.breakpoint.sm}">
            <div class="ml-9 roboto-bold-18 clr-black-38">Создание раздела</div>
            <div class="mt-7 ml-9 roboto-normal-18 clr-black-38">
            Здесь будет анимация, будут меняться картинки, а внизу будет описание того, что происходит
            </div>
        </div>
        <div class="absolute flex arrows pointer" v-if="$vuetify.breakpoint.lgAndUp">
            <v-icon large>mdi-chevron-left</v-icon>
            <v-icon large>mdi-chevron-right</v-icon>
        </div>
        <div class="absolute screen-app-tablet" v-else>
            <v-icon large class="pointer mr-md-12">mdi-chevron-left</v-icon>
            <img class="z-index-10" height="409.45px" width="100%" src="@/assets/images/main/Group 644.png" :class="{sm:$vuetify.breakpoint.sm}">
            <v-icon large class="pointer ml-md-12">mdi-chevron-right</v-icon>
        </div> -->
        <div id="how-its-work" class="absolute logo" :class="{md:$vuetify.breakpoint.md, sm:$vuetify.breakpoint.sm}" v-if="$vuetify.breakpoint.lgAndUp">
            <div class="flex-center">
                <img width="80" src="@/assets/images/logo.svg">
                <div class="logo ml-5">Tasko</div>
                <div class="roboto-bold-36 clr-green ml-7 pointer">Как это работает</div>
            </div>
        </div>
        <div id="how-its-work" class="absolute logo" :class="{md:$vuetify.breakpoint.md, sm:$vuetify.breakpoint.sm}" v-else>
            <div class="flex-center">
                <img width="50" src="@/assets/images/logo.svg">
                <div class="logo mobile ml-5">Tasko</div>
                <div class="roboto-bold-18 clr-green ml-12 pointer z-index-100">Как это работает</div>
            </div>
        </div>
        <div class="absolute bar-top" :class="{lg:$vuetify.breakpoint.lg, md:$vuetify.breakpoint.md, sm:$vuetify.breakpoint.sm}">
            <div class="flex-center">
                <img src="@/assets/images/main/bar_top.png">
                <div class="ml-5">
                    <div class="roboto-400-14 clr-black-38">Раздел</div>
                    <div class="roboto-700-18 clr-black-38 mt-1">Кулинария</div>
                </div>
            </div>
        </div>
        <div class="absolute menu" :class="{lg:$vuetify.breakpoint.lg, md:$vuetify.breakpoint.md, sm:$vuetify.breakpoint.sm}">
            <div class="border ml-10"></div>
            <div class="flex-start">
                <div class="column-one">
                    <div class="arrow arrow-one"></div>
                    <div class="arrow-down arrow-down-one"></div>
                    <div class="ml-12 pl-3">
                        <div class="flex-center">
                            <img src="@/assets/images/main/bar_left.png">
                            <div class="ml-5">
                                <div class="roboto-400-14 clr-black-38">Подраздел</div>
                                <div class="roboto-700-18 clr-black-38 mt-1">Салаты</div>
                            </div>
                        </div>
                    </div>
                    <div class="arrow arrow-two"></div>
                    <div class="arrow-down arrow-down-two"></div>
                    <div class="ml-12 pl-3 mt-3">
                        <div class="flex-center">
                            <img src="@/assets/images/main/text_align_left.png">
                            <div class="ml-5">
                                <div class="roboto-400-14 clr-black-38">Заметка</div>
                                <div class="roboto-700-18 clr-black-38 mt-1">Оливье</div>
                            </div>
                        </div>
                        <div class="ml-11 mt-6 roboto-normal-14">
                            <div>Картофель - 400 г</div>
                            <div>Морковь отварная - 150 г</div>
                            <div>Яйца вареные - 6 шт.</div>
                            <div>Огурцы соленые - 300 г</div>
                            <div>Колбаса вареная - 300 г</div>
                            <div>Майонез - 300 мл </div>
                            <div>Горошек зеленый - 1 банка</div>
                            <div>Лук зеленый - 1 пучок (36 г)</div>
                            <div>Соль - по вкусу</div>
                            <div>Перец молотый - по вкусу</div>
                        </div>
                    </div>
                    <div class="ml-12 pl-3 mt-8">
                        <div class="flex-center">
                            <img src="@/assets/images/main/text_align_left.png">
                            <div class="ml-5">
                                <div class="roboto-400-14 clr-black-38">Заметка</div>
                                <div class="roboto-700-18 clr-black-38 mt-1">Цезарь</div>
                            </div>
                        </div>
                        <div class="ml-11 mt-6 roboto-normal-14">
                            <div>Куpицa - 200 г</div>
                            <div>Лиcтья caлaтa - пучoк</div>
                            <div>Пoмидopы чeppи - 100 г</div>
                            <div>Тepтый пapмeзaн - 100 г</div>
                            <div>Бeлый бaтoн - пoлoвинa</div>
                            <div>Оливкoвoe мacлo - 100 мл</div>
                            <div>Чecнoк - 1-2 зубчикa</div>
                            <div class="mt-2">Для coуca: </div>
                            <div>Куpиный яйцa - 2 шт</div>
                            <div> Гopчицa - 2 ч.лoжки</div>
                            <div> Оливкoвoe мacлo - 100 мл</div>
                            <div>Чecнoк - 1-2 зубчикa</div>
                            <div>Сoк пoлoвины лимона</div>
                        </div>
                    </div>
                </div>
                <div class="column-two ml-1">
                    <div class="arrow arrow-one"></div>
                    <div class="arrow-down arrow-down-one"></div>
                    <div class="ml-2">
                        <div class="flex-center">
                            <img src="@/assets/images/main/bar_left.png">
                            <div class="ml-5">
                                <div class="roboto-400-14 clr-black-38">Подраздел</div>
                                <div class="roboto-700-18 clr-black-38 mt-1">Супы</div>
                            </div>
                        </div>
                    </div>
                    <div class="arrow arrow-two"></div>
                    <div class="arrow-down arrow-down-two"></div>
                    <div class="ml-2 mt-4">
                        <div class="flex-center">
                            <img src="@/assets/images/main/text_align_left.png">
                            <div class="ml-5">
                                <div class="roboto-400-14 clr-black-38">Заметка</div>
                                <div class="roboto-700-18 clr-black-38 mt-1">Солянка</div>
                            </div>
                        </div>
                        <div class="ml-11 mt-6 roboto-normal-14">
                            <div>Говядина - 800 г</div>
                            <div>Колбаса копчёная - 150 г</div>
                            <div>Сосиски - 2-3 шт.</div>
                            <div>Огурцы солёные - 150 г</div>
                            <div>Лук репчатый - 2 шт.</div>
                            <div>Оливки без косточек - 100 г</div>
                            <div>Томатная паста -1 ст. ложка</div>
                            <div>Масло раст. - 4 ст. ложки</div>
                            <div>Лавровый лист - 1 шт</div>
                            <div>Соль - по вкусу</div>
                            <div>Вода - 3 л</div>
                        </div>
                    </div>
                </div>
                <div class="column-three ml-4">
                    <div class="arrow arrow-one"></div>
                    <div class="arrow-down arrow-down-one"></div>
                    <div class="ml-n2">
                        <div class="flex-center">
                            <img src="@/assets/images/main/bar_left.png">
                            <div class="ml-5">
                                <div class="roboto-400-14 clr-black-38">Подраздел</div>
                                <div class="roboto-700-18 clr-black-38 mt-1">Закуски</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'HomeHowItsWork',
    data() {
        return {
            
        }
    },
}
</script>

<style lang="scss" scoped>
$clr-black: #000000;
$clr-white: #FFFFFF;
#home-how-its-work {
    .bkg-grey {
        top:1836px;
        right:0%;
        &.lg {
            width:40.5%
        }
    }
    .bkg-grey-tablet {
        top:2107px;
    }
    .screen-app {
        top:1993px;
        right:5%;
        &.lg {
            width:30%;
            height:309.45px; 
        }
    }
    .screen-app-tablet {
        top:2307px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 8% 0 7%;
        &.sm {
            top:2377px;
            // width:90%;
        }
    }
    .field {
        top:2496px;
        right:0%;
    }
    .field-tablet {
        top:3032px;
    }
    .text {
        top:2497px;
        left:57%;
        margin-right: 7%;
        &.lg {
            left:63%
        }
    }
    .text-tablet {
        top:2817px;
        left:12.5%;
        width:69%;
        &.sm {
            top:2819px;
            left:8%;
        }
    }
    .arrows {
        top:2726px;
        right: 5%;
    }
    .arrows-tablet-one {
        top:2558.48px;
        left:7%;
    }
    .arrows-tablet-two {
        top:2558.48px;
        left:85%;
    }
    .logo {
        top:1994px;
        left:4%;
        &.md, &.sm {
            top:1422px;
            left:6%;
        }
    }
    .bar-top {
        top:2151px;
        left:4%;
        &.lg {
            top:2101px;
        }
        &.md, &.sm {
            top:1538px;
            left:7%;
        }
        &.sm {
            top:1488px;
            left:7%;
        }
    }
    .menu {
        top:2176px;
        left:11%;
        z-index: 9;
        &.lg {
            left:0%;
        }
        &.md, &.sm {
            top:1563px;
            left:23%;
        }
        &.sm {
            top:1563px;
            left:0%;
        }
        .border {
            border: 1px solid #666666;
            width:511px;
        }
        .arrow {
            border: 1px solid #666666;
            transform: rotate(90deg);
        }
        .arrow-down {
            width: 10px;
            height: 10px;
            border-top: 1px solid #666666;
            border-right: 1px solid #666666;
            transform: rotate(135deg);
        }
        .flex-start {
            display: flex;
            align-items: flex-start;
        }
        .column-one {
            .arrow-one {
                margin: 20px 0 0 50px;
                width:43px;
            }
            .arrow-down-one {
                margin: 10px 0 0 66px;
            }
            .arrow-two {
                margin: 30px 0 0 45px;
                width:57px;
            }
            .arrow-down-two {
                margin: 17px 0 0 69px;
            }
        }
        .column-two {
            .arrow-one {
                margin: 20px 0 0 0px;
                width:43px;
            }
            .arrow-down-one {
                margin: 9px 0 0 16px;
            }
            .arrow-two {
                margin: 30px 0 0 -5px;
                width:57px;
            }
            .arrow-down-two {
                margin: 17px 0 0 19px;
            } 
            .text-block {
                width:150px
            }
        }
        .column-three {
            .arrow-one {
                margin: 20px 0 0 -16px;
                width:43px;
            }
            .arrow-down-one {
                margin: 10px 0 0 0px;
            }
            .arrow-two {
                margin: 30px 0 0 -20px;
                width:57px;
            }
            .arrow-down-two {
                margin: 16px 0 0 4px;
            }
            .border {
                border: 1px solid #666666;
                width:105px;
                transform: rotate(90deg);
                margin-left:-44px;
                &.sm {
                    width:165px;
                    margin-left:-44px;
                }
            }
            .border-level {
                border: 1px solid #666666;
                width:5px;
                margin-left:-44px;
                &.sm {
                    margin-left:-74px;
                }
            }
            .border-level-one {
                margin:-41px 0 0 -44px;
                &.sm {
                    margin:-71px 0 0 -74px;
                }

            }
            .border-level-three {
                margin:63px 0 0 -44px;
                &.sm {
                    margin:92.5px 0 0 -74px;
                }
            }
            .border-level-distance {
                margin-left:-32px;
                &.sm {
                    margin-left:-65px;
                }
            }
        }
    }
}
</style>